import React,{useEffect, useState} from "react";
import classes from './Dropdown.module.css';
import DownArrowDropdown from "../DownArrowDropdown/DownArrowDropdown";

const EntryDropdown = (props) => {

    let [dsp,setDsp] = useState("none");
    let [plc,setPlc] = useState('');

    let [options,setOptions] = useState([]);

    useEffect(()=>{
        if(props.plc){
            setPlc(props.plc);
        }
        if(props.options){
            setOptions(props.options);
        }
    },[])

    

    const dspHandler = () =>{
        setDsp("block");
    }

    const dspRemoveHandler = () =>{
        setDsp("none");
    }

    return (
        <>
            <div onMouseLeave={dspRemoveHandler} className={classes['entry-component-search-box-container']}>
                    <div onClick={dspHandler} className={classes['entry-component-search-box']} >
                        <p className={classes['plc-text']} style={{margin:0}}>{plc}</p>
                        <DownArrowDropdown />
                    </div>
                    <div className={classes['entry-dropdown-container']} style={{display:`${dsp}`}}>
                        <div style={{margin:0}}>
                            {
                                options.map(op=>{
                                    return (
                                        <>
                                            <p onClick={()=>{props.tripDataHandler(op.value);setPlc(op.label || op);dspRemoveHandler();}} className={classes['entry-dropdown-options']} >{op.label || op}</p>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
        </>
    )
};

export default EntryDropdown;